export function toRawPrefixedMongoId(id: string, fullPrefix: string): string {
  const prefix = `${fullPrefix}_`;
  return id.startsWith(prefix) ? id.slice(prefix.length) : id;
}

export function toRawMongoTeamId(id: string): string {
  return toRawPrefixedMongoId(id, "m_tm");
}
